import React from "react"
import {connect} from "react-redux"

import rewardAdminActions from "@irati/reward/store/actions/RewardAdminActions"

const mapState = ({reward}) => ({
  reward: reward.reward,
  referenceData: reward.referenceData
})

const mapDispatch = {
  onChange: (reward, key, value) => rewardAdminActions.setRewardValue(reward, key, value)
}

const withRewardOnChange = (PassedComponent) => {
  return connect(mapState, mapDispatch)(
    (props) => <PassedComponent {...props} />
  )
}

export default withRewardOnChange
